'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = undefined;

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2, keyframes) {
  var color = _ref.color,
      size = _ref.size,
      duration = _ref.duration,
      styles = _ref.styles;
  var colors = _ref2.colors,
      rhythm = _ref2.rhythm;

  var dotSize = size / 2;

  var defaultStyles = {
    root: {
      display: 'inline-block',
      height: rhythm(dotSize),
      textAlign: 'center'
    },

    dot: {
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'top',
      margin: 'auto ' + rhythm(dotSize / 3),
      width: rhythm(dotSize),
      height: rhythm(dotSize),
      backgroundColor: colors[color],
      lineHeight: 0,
      borderRadius: '50%',
      transformOrigin: 'bottom',
      animation: keyframes.dots + ' infinite alternate',
      animationDuration: duration + 'ms',

      '&:nth-of-type(2)': {
        animationDelay: '200ms'
      },

      '&:nth-of-type(3)': {
        animationDelay: '400ms'
      }
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};

var keyframes = exports.keyframes = {
  dots: {
    '0%': {
      opacity: 0.1,
      transform: 'scale(0.75)'
    },
    '100%': {
      opacity: 0.9,
      transform: 'scale(1)'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/loading/styles.js
// module id = 858
// module chunks = 0